<template>
    <div class="premium-cta">
        <p> {{ Language.say(text) }}</p>

        <LinkButton
            :link="links.premium"
            :text="Language.say('premium.subscribe_label')"
            class='main-action'
            target="_blank"
            :gtm="gtm"
        />
    </div>
</template>

<script setup>
    import LinkButton     from '@/vue/Elements/Buttons/LinkButton.vue';
    import Language       from '@/js/Shared/Language/Language.js';
    import SAPOMailConfig from '@/SAPOMailConfig';

    const props = defineProps({
        text : {
            default: '',
        },

        gtm: {
            default: null,
        },
    });

    const links  = SAPOMailConfig.server.external_links;
</script>